// istanbul ignore file
// TODO: Remove as part of DMD-4864
import merge from 'lodash/merge';
import pick from 'lodash/pick';

import {
  TARGET_IDENTIFIERS,
  TYPOGRAPHY_STYLE_ATTRIBUTES
} from 'reservations/brand/constants';
import { CIRCULAR_STD, MEDIUM_SOY } from 'reservations/brand/constants';

const BASE_TYPOGRAPHY = Object.freeze({
  color: MEDIUM_SOY,
  fontWeight: '400'
});

export const getTypography = (brandStyles: Record<string, any>) => {
  const defaultTypography = {
    fontFamily: `${CIRCULAR_STD}, Helvetica Neue, Arial, sans-serif`
  };
  const h1: Record<string, any> = merge(
    {
      fontSize: '46px',
      textTransform: 'uppercase'
    },
    BASE_TYPOGRAPHY,
    pick(brandStyles[TARGET_IDENTIFIERS.H1], TYPOGRAPHY_STYLE_ATTRIBUTES)
  );
  const h2: Record<string, any> = merge(
    {
      fontSize: '26px',
      textTransform: 'uppercase'
    },
    BASE_TYPOGRAPHY,
    pick(brandStyles[TARGET_IDENTIFIERS.H2], TYPOGRAPHY_STYLE_ATTRIBUTES)
  );
  const h3: Record<string, any> = merge(
    {
      fontSize: '16px',
      textTransform: 'uppercase'
    },
    BASE_TYPOGRAPHY,
    pick(brandStyles[TARGET_IDENTIFIERS.H3], TYPOGRAPHY_STYLE_ATTRIBUTES)
  );
  const body1: Record<string, any> = merge(
    { fontSize: '16px' },
    BASE_TYPOGRAPHY,
    pick(
      brandStyles[TARGET_IDENTIFIERS.PARAGRAPH],
      TYPOGRAPHY_STYLE_ATTRIBUTES
    ),
    { textTransform: 'none' }
  );
  const button: Record<string, any> = merge(
    {
      textTransform: 'uppercase',
      fontSize: '18px',
      fontWeight: 500
    },
    BASE_TYPOGRAPHY,
    pick(
      brandStyles[TARGET_IDENTIFIERS.PRIMARY_BUTTON],
      TYPOGRAPHY_STYLE_ATTRIBUTES
    )
  );
  const caption: Record<string, any> = merge(
    {},
    BASE_TYPOGRAPHY,
    pick(
      brandStyles[TARGET_IDENTIFIERS.PARAGRAPH],
      TYPOGRAPHY_STYLE_ATTRIBUTES
    ),
    { fontSize: '12px', textTransform: 'none', lineHeight: 'normal' }
  );

  const typography = {
    h1,
    h2,
    h3,
    body1,
    button,
    caption,
    fontFamily: h3?.fontFamily
  };

  return merge({}, defaultTypography, typography);
};

const cssFontFace = (
  name: string,
  src: String,
  fontWeight: string | number = 'normal',
  fontStyle: string = 'normal'
) => `
@font-face {
  font-family: ${name};
  src: url(https://media-cdn.getbento.com/fonts/circular/${src}.eot?#iefix) format('embedded-opentype'),
       url(https://media-cdn.getbento.com/fonts/circular/${src}.otf) format('opentype'),
       url(https://media-cdn.getbento.com/fonts/circular/${src}.woff) format('woff'),
       url(https://media-cdn.getbento.com/fonts/circular/${src}.woff2) format('woff2'),
       url(https://media-cdn.getbento.com/fonts/circular/${src}.ttf) format('truetype'),
       url(https://media-cdn.getbento.com/fonts/circular/${src}.svg#${name}) format('svg');
  font-style: ${fontStyle};
  font-weight: ${fontWeight};
  font-display: swap;
}
`;

export const loadBrandFont = () => [
  cssFontFace(CIRCULAR_STD, `${CIRCULAR_STD}-Book`, 400),
  cssFontFace(CIRCULAR_STD, `${CIRCULAR_STD}-Medium`, 500),
  cssFontFace(CIRCULAR_STD, `${CIRCULAR_STD}-Bold`, 700),
  cssFontFace(CIRCULAR_STD, `${CIRCULAR_STD}-BookItalic`, 300, 'italic')
];
